import { Skeleton } from '@mui/material';

import { Stack } from '../Stack/Stack';

const widths = ['15%', '50%', '40%', '60%', '55%', '48%', '44%'] as const;
const letters = 'abcdefghijklmnopqrstuvw' as const;

interface Props {
  size: 1 | 3 | 7;
}

export function Skeletons({ size }: Props) {
  return (
    <Stack gap="1rem">
      {Array.from(letters.slice(0, size)).map((key, index) => (
        <Skeleton key={key} animation="pulse" variant="text" width={widths[index]} />
      ))}
    </Stack>
  );
}
